module.exports = __webpack_public_path__ + "img/img5.f9750a60.jpg";